enum PageName {
  HOME = 'Homepage',
  EXPLORE = 'Explore',
  PROGRAM = 'Program',
  ALL_PROGRAMS = 'All Programs',
}

export default PageName;
